import { render, staticRenderFns } from "./VmForm.vue?vue&type=template&id=118f6a01&scoped=true&"
import script from "./VmForm.vue?vue&type=script&lang=js&"
export * from "./VmForm.vue?vue&type=script&lang=js&"
import style0 from "./VmForm.vue?vue&type=style&index=0&id=118f6a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f6a01",
  null
  
)

export default component.exports